/**
 * Search search
 */
 const searchOverlay = () => {

  // setup args
  let search              = document.querySelector('.js-search-overlay');
  let site                = document.querySelector('.js-page');
  let toggles             = document.querySelectorAll('.js-search-close');
  let searchOpenButton    = document.querySelectorAll('.js-search-toggle a');

  // validate
  if (!search || !searchOpenButton || !site) {
    console.log('Invalid search args');
    return;
  }

  // setup a11y dialog
  const dialog = new A11yDialog(search, site);

  // tasks to open search visually
  const openSearch = () => {
   document.body.classList.add('is-active-search');
   const searchInput = document.querySelector('.js-search-overlay input[type="search"]');
   if (searchInput) {
     searchInput.focus();
   }
  };

  // tasks to close search visually
  const closeSearch = () => {

    document.body.classList.add('is-closing-search');
    setTimeout(() => {
      document.body.classList.remove('is-active-search');
      document.body.classList.remove('is-closing-search');
     }, 200);

  };

  // hooks
  dialog.on('show', (element, event) => {
    openSearch();
  });
  dialog.on('hide', (element, event) => {
    closeSearch();
  });

  // toggle click
  const handleToggle = (e) => {

    e.preventDefault();
    if (document.body.classList.contains('is-active-search')) {
        e.currentTarget.setAttribute('aria-pressed', 'false');
        dialog.hide();
    } else {
      dialog.show();
      document.body.classList.remove('is-active-menu');
      e.currentTarget.setAttribute('aria-pressed', 'true');
      const input = document.querySelector('.js-ajax-search-form-input');
      if (input) {
        input.focus();
      }
    }
  };

  for (var i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener('click', handleToggle, false);
  }

  for (let i = 0; i < searchOpenButton.length; i++) {
    searchOpenButton[i].addEventListener('click', handleToggle, false);
  }

  // make the call chainable
  return this;

};

searchOverlay();
